import * as angular from 'angular';

import { IdentityScimComponent } from '~/modules/org-settings/components/identity/identity-scim/identity-scim.component';

import { IdentityScimService } from './identity-scim.service';

export const IdentityScimModule = angular
  .module('identity-scim', [])
  .service('IdentityScimService', IdentityScimService)
  .component('identityScim', IdentityScimComponent).name;
